export const tutorialRoutes = [
  {
    path: "/tutorial",
    name: "tutorial-index",
    component: () => import(/* webpackChunkName: "tutorial-index" */ "@/views/tutorial/Index.vue"),
  },
];
